module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warningMsg":" This report shows the domain authority of the root domain"},"fr":{"warningMsg":" Ce rapport affiche le domain authority du domaine racine"},"de":{"warningMsg":"Dieser Bericht zeigt die Domänenautorität der Stammdomäne an"}}')
  delete Component.options._Ctor
}
